import { Typography } from '@mui/material';

import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';
import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { ActionComponentProps } from '../../index';

export const FinishReturnToSender = ({ mailpieces, actionStarted, onActionFinish }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const confirmAction = async () => {
    await updatePieces({
      pieces: mailpieces.map((piece) => ({ id: piece.id })),
      action: PieceAction.FinishReturnToSender,
    }).unwrap();

    onActionFinish();
  };

  return (
    <DialogConfirmation
      open={actionStarted}
      loading={isLoading}
      maxWidth="xs"
      title={mailpieces.length === 1 ? 'Return item to sender' : 'Return selected items to senders'}
      content={
        <Typography variant="body1" color="text.secondary">
          {mailpieces.length === 1 ? (
            <>Please return this item to its sender, and click Complete when you’re done.</>
          ) : (
            <>
              Please return <strong>{mailpieces.length}</strong> items to their senders, and click Complete when you’re
              done.
            </>
          )}
        </Typography>
      }
      acceptButtonHandleClick={confirmAction}
      cancelButtonHandleClick={onActionFinish}
      acceptButtonTitle="Complete"
      cancelButtonTitle="Cancel"
    />
  );
};
